<template>
  <star-rating
      @rating-selected="setRating($event)"
      v-model="rating"
      :read-only="readonly"
      :show-rating="false"
      :star-size="size"
      :increment="increment"
      :fixed-points="fixedpoints"
      :active-color="activeColor"
      :inactive-color="inactiveColor"
      :border-color="activeColor"
      :border-width="1"
  />
</template>

<script>
import StarRating from 'vue-star-rating'
import exhibitionApi from '~/api/exhibition'
import programApi from '~/api/program'

export default {
  data() {
    return {
      selectedRating: null,
    }
  },
  computed: {
    rating: {
      get() {
        if (this.overallRating) {
          return this.overallRating
        }
        return this.myrating
      },
      set(newValue) {
        this.selectedRating = newValue
      },
    },

  },
  components: { StarRating },
  props: {
    readonly: {
      default: false,
      type: Boolean,
    },
    id: {
      default: '',
      type: String,
    },
    userId: {
      default: null,
      type: Number,
    },
    overallRating: {
      type: Number,
      default: null,
    },
    myrating: {
      type: Number,
      default: null,
    },
    increment: {
      type: Number,
      default: 1,
    },
    fixedpoints: {
      type: Number,
      default: null,
    },
    size: {
      default: 20,
      type: Number,
    },
    activeColor: {
      type: String,
      default: '#ffd055',
    },
    inactiveColor: {
      type: String,
      default: '#d8d8d8',
    },
    ratingContext: {
      type: String,
      default: 'Product',
    },

  },
  methods: {
    setRating(selectedRating) {
      if (this.ratingContext === 'Session') {
        try {
          programApi.createSessionRating(this.id, '', selectedRating)
        } catch (e) {
          console.log('error: ', e)
        }
      } else if (this.ratingContext === 'Presentation') {
        console.log(this.ratingContext)

        try {
          programApi.createPresentationRating(this.id, this.userId, '', selectedRating)
        } catch (e) {
          console.log('error: ', e)
        }
      } else {
        try {
          exhibitionApi.createRatingForProduct(this.id, selectedRating)
          this.$emit('rated')
        } catch (e) {
          console.log('error: ', e)
        }
      }
    },
  },
}
</script>

<style>

</style>
